import { Box, Sheet, Typography } from '@mui/joy';
import { FC, JSX } from 'react';
import { useNavigate } from 'react-router';
import { PageBreadcrumbs } from '@consolidocs-ui/components';
import CompanyForm from './CompanyForm';

/**
 * Full-page Create Organization screen. Shell mirrors CreateIndustry / CreateContract
 * so the super-admin app has a consistent page-level create pattern.
 */
const CreateCompanyPage: FC = (): JSX.Element => {
  const navigate = useNavigate();

  const goToList = () => navigate('/');

  return (
    <Box sx={{ flex: 1, width: '100%' }}>
      {/* Breadcrumbs pinned to the top of the viewport, using the same
          grey as `main-content` so the scrolling form slides underneath
          without a visible white bar. */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 9995,
          bgcolor: '#f5f5f5',
          // Cancel the .content wrapper's top padding (p-4) so the bar sticks
          // flush to the top instead of drifting down before it engages.
          mt: { md: -2 },
          pt: { xs: 1, md: 2 },
          pb: 1,
        }}
      >
        <PageBreadcrumbs
          items={[
            { label: 'Companies', path: '/' },
            { label: 'Create Organization' },
          ]}
        />
      </Box>

      <Sheet
        variant="outlined"
        sx={{
          width: { xs: '100%', sm: '95%', md: '900px' },
          maxWidth: '900px',
          mx: 'auto',
          p: { xs: 2, sm: 3, md: 4 },
          borderRadius: 'md',
          boxShadow: 'sm',
          borderColor: 'neutral.outlinedBorder',
          marginTop: { xs: '12px', md: '20px' },
        }}
      >
        <Typography level="h4" mb={2}>
          Create Organization
        </Typography>

        <CompanyForm onCancel={goToList} onSuccess={goToList} />
      </Sheet>
    </Box>
  );
};

export default CreateCompanyPage;
